import storageKeys from './storageKeys';
import {
  companyUUID,
  getCookie,
  getLocal,
  getShopifyUserId,
  setCookie,
  setLocal
} from './oneIDContext';
import { notifyOidSettled } from './oidSettle';

const STORAGE_KEY = { ONE_ID: storageKeys.CARTSEE_ONEID };

const ONEID_ORIGIN = 'https://d39va5bdt61idd.cloudfront.net';

/** 仅 Shopify 有 analytics.publish；其它渠道 optional chain 直接 no-op，不抛错 */
function publishOneIdToPixel(oneId) {
  if (!oneId) return;
  try {
    window?.Shopify?.analytics?.publish?.('cartsee_oneid_settled', { oid: oneId });
  } catch (e) {
    /* 主题/沙箱未就绪时忽略 */
  }
}

export function getOneId() {
  // 添加消息处理器之前先移除旧的，避免重复监听
  const messageHandler = function (event) {
    // 严格检查来源域名
    if (event.origin !== ONEID_ORIGIN) {
      // 只有当消息看起来像是尝试模仿我们的协议时才记录
      if (event.data && (event.data.type === "COOKIE_RESPONSE" || event.data.type === "GET_COOKIE")) {
        console.warn('收到可疑来源消息:', event.origin);
      }
      return;
    }

    // 检查消息格式
    if (!event.data || event.data.type !== "COOKIE_RESPONSE") {
      return;
    }

    const oneId = event.data.payload?.oneId;

    if (!oneId) {
      console.warn('接收到空的oneId');
      // return 时机不变；仅在此前通知门禁「oid 流程结束、值为空」
      notifyOidSettled('');
      return;
    }

    try {
      // 跨域 iframe 回传的 oneId 同时写 cookie 与 local，供主站读取
      setCookie(STORAGE_KEY.ONE_ID, oneId);
      setLocal(STORAGE_KEY.ONE_ID, oneId);
      notifyOidSettled(oneId);
      publishOneIdToPixel(oneId);
      window?.postMessage('_cartsee_send');
    } catch (e) {
      console.error('存储数据失败:', e);
      notifyOidSettled('');
    }
  };

  // 移除可能存在的旧监听器
  window.removeEventListener('message', messageHandler);
  window.addEventListener('message', messageHandler);

  // 修改：添加额外的安全属性
  const iframe = document.createElement('iframe');
  iframe.id = 'cookieReader';
  // iframe.src = 'https://image.cartx.cloud/cartsee-one/index.html';
  iframe.src = `${ONEID_ORIGIN}/onsite/index.html`;
  // 基础样式设置
  iframe.style.cssText = 'display:none; width:0; height:0; border:0; position:absolute;';
  // 只保留关键的安全属性
  iframe.setAttribute('crossorigin', 'use-credentials');
  iframe.setAttribute('sandbox', 'allow-scripts allow-same-origin allow-forms');
  document.body.appendChild(iframe);

  // 添加错误处理
  iframe.onerror = function (error) {
    console.error('iframe 加载失败:', error);
    notifyOidSettled('');
  };

  // 等待iframe加载完成后再发送消息
  iframe.onload = function () {
    iframe.contentWindow.postMessage({
      type: 'GET_COOKIE',
      payload: {
        companyUuid: companyUUID,
        shopifyUserId: getShopifyUserId()
      }
    }, '*');
  };
}

export function oneidInit() {
  const oneId = getCookie(STORAGE_KEY.ONE_ID) || getLocal(STORAGE_KEY.ONE_ID);
  if (!oneId) {
    getOneId();
  } else {
    // 本地已有 oid：成功路径不改；补 settle 让门禁不必空等
    notifyOidSettled(oneId);
    publishOneIdToPixel(oneId);
  }
}
